import React, { useEffect, useState } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { Testimonials } from '../components/Testimonials';
import { OrderBump } from '../components/OrderBump';
import { FinalOffer } from '../components/FinalOffer';
import { FAQ } from '../components/FAQ';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { StickyCTA } from '../components/StickyCTA';
export function LandingPage() {
  const [isOrderBumpChecked, setIsOrderBumpChecked] = useState(false);
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full bg-cream font-sans text-brown selection:bg-forest/20" data-id="element-230">
      <HeroSection data-id="element-231" />
      <PainSection data-id="element-232" />
      <RevelationSection data-id="element-233" />
      <ValueStack data-id="element-234" />
      <Testimonials data-id="element-235" />

      {/* Wrapper for Order Bump to sit right above Final Offer */}
      <section className="bg-cream pt-10 pb-4" data-id="element-236">
        <div className="max-w-3xl mx-auto px-4" data-id="element-237">
          <OrderBump isChecked={isOrderBumpChecked} onToggle={() => setIsOrderBumpChecked(!isOrderBumpChecked)} data-id="element-238" />
        </div>
      </section>

      <FinalOffer isOrderBumpChecked={isOrderBumpChecked} data-id="element-239" />
      <FAQ data-id="element-240" />

      <RecentPurchaseToast data-id="element-241" />
      <StickyCTA isOrderBumpChecked={isOrderBumpChecked} data-id="element-242" />

      <footer className="bg-brown text-parchment/60 py-8 text-center text-sm pb-24" data-id="element-243">
        <p data-id="element-244">
          © {new Date().getFullYear()} Botiquín Ancestral. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs opacity-50" data-id="element-245">
          Este manual te enseña el rol de apoyo de la medicina natural — sin
          reemplazar emergencias médicas
        </p>
      </footer>
    </main>;
}